import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";
import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import type { AssignmentSource } from "modules/aiMapping/aiAssignmentSources";
import type { AssignedSource } from "./aiAssignmentTypes";
import { selectSx } from "./aiAssignmentTypes";

export default function SourceChip({
  source,
  assignment,
  linearFeetAllowed,
  onRemove,
  onStallModeChange,
}: {
  source: AssignmentSource;
  assignment: AssignedSource;
  linearFeetAllowed: boolean;
  onRemove: () => void;
  onStallModeChange: (mode: "count" | "linear_ft") => void;
}) {
  return (
    <MDBox
      p={0.75}
      display="flex"
      alignItems="center"
      gap={0.75}
      sx={{ border: "1px solid #e3e8ee", borderRadius: "9px", bgcolor: "#fafbfc" }}
    >
      <MDBox
        sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: source.color, flexShrink: 0 }}
      />
      <MDBox sx={{ flex: 1, minWidth: 0 }}>
        <UiTypography uiVariant="caption" sx={{ fontWeight: 700, display: "block" }}>
          {source.label}
        </UiTypography>
        <UiTypography uiVariant="caption" sx={{ color: "#667085", display: "block" }}>
          {source.detail}
        </UiTypography>
      </MDBox>
      {source.stallLinearFeet != null && (
        <MDBox
          component="select"
          value={assignment.stallMode ?? "count"}
          onChange={(event: any) => onStallModeChange(event.target.value)}
          sx={{ ...selectSx, width: 92, height: 26, fontSize: 10 }}
          aria-label={`Value for ${source.label}`}
        >
          <option value="count">Count</option>
          <option
            value="linear_ft"
            disabled={!linearFeetAllowed}
            title={linearFeetAllowed ? undefined : "Choose a linear foot product first"}
          >
            Linear ft
          </option>
        </MDBox>
      )}
      <IconButton size="small" onClick={onRemove} title={`Remove ${source.label}`}>
        <DeleteOutlineIcon fontSize="small" />
      </IconButton>
    </MDBox>
  );
}
